var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "revising-editor-save-actions" }, [
    _c(
      "button",
      {
        staticClass: "revising-editor-save-actions__save-button",
        attrs: {
          type: "button",
          disabled: _vm.isSaving || _vm.isApplying || !_vm.hasUnsavedChanges,
        },
        on: { click: _setup.onClickSave },
      },
      [_vm._v(" " + _vm._s(_setup.tempSaveLabel) + " ")]
    ),
    _c(
      "button",
      {
        staticClass: "revising-editor-save-actions__apply-button",
        attrs: { type: "button", disabled: _vm.isApplying || _vm.isSaving },
        on: { click: _setup.onClickApply },
      },
      [_vm._v(" " + _vm._s(_setup.applyLabel) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }